import { createRoot } from "react-dom/client";
import { StoreProvider } from "../app/storeProvider";
import React from "react";
import BotbLeaderBoardPage from "../app/(general-header)/everybody-wins/page";

const root = createRoot(document.getElementById("botb-pass-leaderboard-page-container") as HTMLElement);

root.render(
  <React.StrictMode>
    <StoreProvider>
      <BotbLeaderBoardPage />
    </StoreProvider>
  </React.StrictMode>
);
